/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import clsx from 'clsx'

type UiSectionHeaderProps = {
    title: React.ReactNode
    description?: React.ReactNode
    actions?: React.ReactNode
    className?: string
}

const UiSectionHeader: React.FC<UiSectionHeaderProps> = ({
    title,
    description,
    actions,
    className,
}) => {
    return (
        <div
            className={clsx(
                'UiSectionHeader flex items-start justify-between gap-4',
                className
            )}
        >
            <div className={clsx('flex flex-col gap-1')}>
                <h2
                    className={clsx(
                        'text-base font-semibold text-gray-900 dark:text-gray-100'
                    )}
                >
                    {title}
                </h2>
                {description && (
                    <p
                        className={clsx(
                            'text-sm text-gray-500 dark:text-gray-400'
                        )}
                    >
                        {description}
                    </p>
                )}
            </div>
            {actions && (
                <div className={clsx('flex items-center gap-2')}>{actions}</div>
            )}
        </div>
    )
}

export default UiSectionHeader
